import Validator from '../validator';

Validator.register('integer', (value: string) => {
  let message: string | null = null;
  if (value && !/^(-)?\d+$/.test(value)) {
    message = 'Invalid number';
  }
  return message;
});
